import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { RedirectByParams } from './components/Redirect'

const router = createBrowserRouter(
    [
        //Rotas logado
        {
            path: '/',
            element: <RedirectByParams />,
            // children: [
            //     {
            //         index: '/',
            //         element: <PrivateRoute />,
            //         children: [
            //             {
            //                 path: '/',
            //                 element: <InternalLayout />,
            //                 children: [
            //                     {
            //                         index: true,
            //                         element: <Dashboard />,
            //                     },
            //                     {
            //                         path: 'processes',
            //                         handle: { crumb: { title: 'SYSTEM_TITLE' } },
            //                         children: [
            //                             {
            //                                 index: true,
            //                                 element: (
            //                                     <PermissionedRoute routePermissions={EModulePermissions.INTERNAL}>
            //                                         <ListProcess />
            //                                     </PermissionedRoute>
            //                                 ),
            //                             },
            //                             {
            //                                 path: 'rae-creation/:processItemIds/:idPackage',
            //                                 element: (
            //                                     <Breadcrumb>
            //                                         <PermissionedRoute routePermissions={[EModulePermissions.BUYER.code]}>
            //                                             <RaeCreation />
            //                                         </PermissionedRoute>
            //                                     </Breadcrumb>
            //                                 ),
            //                                 handle: {
            //                                     crumb: { title: 'RAE_CRIATION' },
            //                                 },
            //                             },
            //                             {
            //                                 path: 'budget-adequacy-creation/:processItemId',
            //                                 element: (
            //                                     <Breadcrumb>
            //                                         <PermissionedRoute routePermissions={[EModulePermissions.BUYER.code]}>
            //                                             <BudgetAdequacyCreation />
            //                                         </PermissionedRoute>
            //                                     </Breadcrumb>
            //                                 ),
            //                                 handle: {
            //                                     crumb: { title: 'BUDGET_ADEQUACY_CREATION' },
            //                                 },
            //                             },
            //                             {
            //                                 path: 'technical-advice-creation/:processItemId',
            //                                 element: (
            //                                     <Breadcrumb>
            //                                         <PermissionedRoute routePermissions={[EModulePermissions.BUYER.code]}>
            //                                             <TechnicalReport />
            //                                         </PermissionedRoute>
            //                                     </Breadcrumb>
            //                                 ),
            //                                 handle: {
            //                                     crumb: { title: 'TECHNICAL_ADVICE_CREATION' },
            //                                 },
            //                             },
            //                             {
            //                                 path: 'details/:idItem',
            //                                 handle: {
            //                                     crumb: {
            //                                         title: 'ITEM_DETAILS_CRUMB',
            //                                         params: ['idItem'],
            //                                     },
            //                                 },
            //                                 children: [
            //                                     {
            //                                         index: true,
            //                                         element: (
            //                                             <Breadcrumb>
            //                                                 <ItemDetails />
            //                                             </Breadcrumb>
            //                                         ),
            //                                     },
            //                                 ],
            //                             },
            //                         ],
            //                     },
            //                     {
            //                         path: 'buyers-list',
            //                         handle: { crumb: { title: 'BUYERS_LIST' } },
            //                         children: [
            //                             {
            //                                 index: true,
            //                                 element: (
            //                                     <Breadcrumb>
            //                                         <PermissionedRoute routePermissions={EModulePermissions.INTERNAL}>
            //                                             <BuyersList />
            //                                         </PermissionedRoute>
            //                                     </Breadcrumb>
            //                                 ),
            //                             },
            //                             {
            //                                 path: ':idBuyer',
            //                                 element: (
            //                                     <Breadcrumb>
            //                                         <PermissionedRoute routePermissions={EModulePermissions.INTERNAL}>
            //                                             <DetailsBuyer />
            //                                         </PermissionedRoute>
            //                                     </Breadcrumb>
            //                                 ),
            //                                 handle: {
            //                                     crumb: {
            //                                         title: 'BUYER_DETAILS_CRUMB',
            //                                         params: ['idBuyer'],
            //                                     },
            //                                 },
            //                             },
            //                         ],
            //                     },
            //                     {
            //                         path: 'technical-report/:idTechnicalReport',
            //                         handle: {
            //                             crumb: {
            //                                 title: 'TECHNICAL_REPORT_DETAILS',
            //                             },
            //                         },
            //                         element: (
            //                             <Breadcrumb>
            //                                 <TechnicalReportDetails />
            //                             </Breadcrumb>
            //                         ),
            //                     },
            //                     {
            //                         path: 'budget-adequacy/:idBudjetAdequacy',
            //                         handle: {
            //                             crumb: {
            //                                 title: 'BUDGET_ADEQUACY_DETAILS',
            //                             },
            //                         },
            //                         element: (
            //                             <Breadcrumb>
            //                                 <BudgetAdequacyDetails />
            //                             </Breadcrumb>
            //                         ),
            //                     },
            //                     {
            //                         path: 'rae',
            //                         handle: { crumb: { title: 'RAE' } },
            //                         children: [
            //                             {
            //                                 index: true,
            //                                 element: (
            //                                     <Breadcrumb>
            //                                         <PermissionedRoute routePermissions={[...EModulePermissions.INTERNAL, EModulePermissions.GENERAL_VISUALIZATION.code]}>
            //                                             <Rae />
            //                                         </PermissionedRoute>
            //                                     </Breadcrumb>
            //                                 ),
            //                             },
            //                             {
            //                                 path: ':idRae',
            //                                 element: (
            //                                     <Breadcrumb>
            //                                         <PermissionedRoute routePermissions={[...EModulePermissions.INTERNAL, EModulePermissions.GENERAL_VISUALIZATION.code]}>
            //                                             <RaeDetails />
            //                                         </PermissionedRoute>
            //                                     </Breadcrumb>
            //                                 ),
            //                                 handle: {
            //                                     crumb: { title: 'RAE_DETAILS', params: ['idRae'] },
            //                                 },
            //                             },
            //                         ],
            //                     },
            //                     {
            //                         path: 'system-params',
            //                         element: (
            //                             <Breadcrumb>
            //                                 <PermissionedRoute routePermissions={EModulePermissions.INTERNAL}>
            //                                     <SystemParams />
            //                                 </PermissionedRoute>
            //                             </Breadcrumb>
            //                         ),
            //                         handle: { crumb: { title: 'SYSTEM_PARAMS_TITLE' } },
            //                     },
            //                     {
            //                         path: 'logs',
            //                         element: (
            //                             <Breadcrumb>
            //                                 <PermissionedRoute routePermissions={[EModulePermissions.ADMIN.code, EModulePermissions.SUPER_ADMIN.code]}>
            //                                     <Logs />
            //                                 </PermissionedRoute>
            //                             </Breadcrumb>
            //                         ),
            //                         handle: { crumb: { title: 'LOGS' } },
            //                     },
            //                     {
            //                         path: 'processes-list',
            //                         handle: { crumb: { title: 'PROCESSES_lIST' } },
            //                         children: [
            //                             {
            //                                 index: true,
            //                                 element: (
            //                                     <Breadcrumb>
            //                                         <ProcessesList />
            //                                     </Breadcrumb>
            //                                 ),
            //                             },
            //                             {
            //                                 path: ':idProcess',
            //                                 handle: {
            //                                     crumb: {
            //                                         title: 'PROCESS_DETAILS_CRUMB',
            //                                         params: ['idProcess'],
            //                                     },
            //                                 },
            //                                 children: [
            //                                     {
            //                                         index: true,
            //                                         element: (
            //                                             <Breadcrumb>
            //                                                 <ProcessDetails />
            //                                             </Breadcrumb>
            //                                         ),
            //                                     },
            //                                     {
            //                                         path: ':idItem',
            //                                         handle: {
            //                                             crumb: {
            //                                                 title: 'ITEM_DETAILS_CRUMB',
            //                                                 params: ['idItem'],
            //                                             },
            //                                         },
            //                                         children: [
            //                                             {
            //                                                 index: true,
            //                                                 element: (
            //                                                     <Breadcrumb>
            //                                                         <ItemDetails />
            //                                                     </Breadcrumb>
            //                                                 ),
            //                                             },
            //                                         ],
            //                                     },
            //                                 ],
            //                             },
            //                         ],
            //                     },
            //                     {
            //                         path: 'notifications',
            //                         element: (
            //                             <Breadcrumb>
            //                                 <PermissionedRoute routePermissions={EModulePermissions.INTERNAL}>
            //                                     <Notifications />
            //                                 </PermissionedRoute>
            //                             </Breadcrumb>
            //                         ),
            //                         handle: { crumb: { title: 'NOTIFICATION_LIST' } },
            //                     },
            //                     {
            //                         path: 'profile',
            //                         element: (
            //                             <Breadcrumb>
            //                                 <ProfileDetails />
            //                             </Breadcrumb>
            //                         ),
            //                     },
            //                     {
            //                         path: 'docs',

            //                         element: (
            //                             <Breadcrumb>
            //                                 <PermissionedRoute routePermissions={[EModulePermissions.DOCUMENTATION_VIEWER.code, EModulePermissions.DOCUMENTATION_EDITOR.code]}>
            //                                     <Documentation />
            //                                 </PermissionedRoute>
            //                             </Breadcrumb>
            //                         ),

            //                         handle: { crumb: { title: 'DOCUMENTATION' } },
            //                     },
            //                 ],
            //             },
            //         ],
            //     },
            // ],
        }
    ],
    { basename: '/microservice-approvals' }
)

export function Router() {
    // const { setLoggedUser, setCurrentUser, setUserPermissions } = useContext(AuthContext)

    // const { setShowLoading, showAlert } = useContext(GeneralContext)

    // useLayoutEffect(() => {
    //     axiosInstance.interceptors.request.use(function (config) {
    //         return config
    //     })

    //     axiosInstance.interceptors.response.use(
    //         function (rs) {
    //             return rs
    //         },
    //         function (err) {
    //             setShowLoading(false)

    //             if (err?.response?.data?.redirect_to_login) {
    //                 setLoggedUser(false)
    //                 setCurrentUser(null)
    //                 setUserPermissions(null)
    //             } else if (err?.response?.data?.error) {
    //                 showAlert(err?.response?.data?.error)
    //             }
    //             return Promise.reject(err)
    //         }
    //     )

    //     axiosInstancePortal.interceptors.response.use(
    //         function (rs) {
    //             return rs
    //         },
    //         function (err) {
    //             setShowLoading(false)

    //             if (err?.response?.data?.redirect_to_login) {
    //                 setLoggedUser(false)
    //                 setCurrentUser(null)
    //                 setUserPermissions(null)
    //             } else if (err?.response?.data?.error) {
    //                 showAlert(err?.response?.data?.error)
    //             }
    //             return Promise.reject(err)
    //         }
    //     )
    // }, [])

    return <RouterProvider router={router} />
}
